<template>
  <div class="stats">
    <!-- Переключатель периода -->
    <div class="period-tabs">
      <button
        v-for="p in periods"
        :key="p.value"
        class="period-tab"
        :class="{ active: period === p.value }"
        @click="setPeriod(p.value)"
      >
        {{ p.label }}
      </button>
    </div>

    <div v-if="loading" class="loading">Загрузка...</div>

    <template v-else>
      <div class="cards">
        <div class="card card-total">
          <div class="card-value">{{ stats.total }}</div>
          <div class="card-label">Всего примеров</div>
        </div>
        <div class="card card-correct">
          <div class="card-value">{{ stats.correct }}</div>
          <div class="card-label">Правильных</div>
          <div class="card-percent">{{ stats.correct_percent }}%</div>
        </div>
        <div class="card card-wrong">
          <div class="card-value">{{ stats.wrong }}</div>
          <div class="card-label">Неправильных</div>
          <div class="card-percent">{{ stats.wrong_percent }}%</div>
        </div>
      </div>

      <div v-if="stats.top_wrong && stats.top_wrong.length" class="top-wrong">
        <h3>Чаще всего ошибались:</h3>
        <div
          v-for="(item, index) in stats.top_wrong"
          :key="index"
          class="top-wrong-item"
        >
          <span class="top-wrong-example">
            {{ item.factor_a }} × {{ item.factor_b }}
          </span>
          <span class="top-wrong-count">{{ item.wrong_count }} ошибок</span>
        </div>
      </div>

      <div v-else class="empty">За этот период нет данных об ошибках</div>

      <button
        v-if="stats.total > 0"
        class="btn-reset"
        :disabled="resetting"
        @click="resetStats"
      >
        {{ resetting ? "Сброс..." : "Начать заново" }}
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MathStats',
  data () {
    return {
      loading: true,
      resetting: false,
      period: 'all',
      periods: [
        { value: 'today', label: 'Сегодня' },
        { value: 'week', label: 'За неделю' },
        { value: 'month', label: 'За месяц' },
        { value: 'all', label: 'Всё время' }
      ],
      stats: {
        total: 0,
        correct: 0,
        wrong: 0,
        correct_percent: 0,
        wrong_percent: 0,
        top_wrong: []
      }
    }
  },
  mounted () {
    this.loadStats()
  },
  methods: {
    async loadStats () {
      this.loading = true
      try {
        const res = await fetch(
          `${process.env.VUE_APP_API_URL}/api/get_stats.php?period=${this.period}`
        )
        const data = await res.json()
        this.stats = data
      } catch (e) {
        console.error('Ошибка загрузки статистики', e)
      } finally {
        this.loading = false
      }
    },
    setPeriod (p) {
      if (this.period === p) return
      this.period = p
      this.loadStats()
    },
    async resetStats () {
      if (
        !confirm(
          'Вы уверены, что хотите сбросить всю статистику? Это действие нельзя отменить.'
        )
      ) {
        return
      }

      this.resetting = true

      try {
        const res = await fetch(
          `${process.env.VUE_APP_API_URL}/api/reset_stats.php`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
          }
        )

        const data = await res.json()

        if (data.success) {
          this.stats = {
            total: 0,
            correct: 0,
            wrong: 0,
            correct_percent: 0,
            wrong_percent: 0,
            top_wrong: []
          }
        } else {
          alert('Ошибка: ' + (data.error || 'неизвестная'))
        }
      } catch (e) {
        console.error('Ошибка сброса:', e)
        alert('Не удалось сбросить статистику')
      } finally {
        this.resetting = false
      }
    }
  }
}
</script>

<style scoped>
.stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #718096;
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

@media (min-width: 480px) {
  .cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-left: 4px solid transparent;
}

.card-total {
  border-left-color: #4299e1;
}

.card-correct {
  border-left-color: #48bb78;
}

.card-wrong {
  border-left-color: #f56565;
}

.card-value {
  font-size: 36px;
  font-weight: 700;
  color: #2d3748;
  line-height: 1;
  margin-bottom: 8px;
}

.card-label {
  font-size: 14px;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-percent {
  font-size: 20px;
  font-weight: 600;
  margin-top: 8px;
}

.card-correct .card-percent {
  color: #48bb78;
}

.card-wrong .card-percent {
  color: #f56565;
}

.top-wrong {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.top-wrong h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: #2d3748;
}

.top-wrong-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #edf2f7;
}

.top-wrong-item:last-child {
  border-bottom: none;
}

.top-wrong-example {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
}

.top-wrong-count {
  font-size: 14px;
  color: #f56565;
  font-weight: 600;
}

.empty {
  text-align: center;
  padding: 24px;
  color: #a0aec0;
  background: #fff;
  border-radius: 12px;
}
.btn-reset {
  width: 100%;
  padding: 16px;
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #e53e3e;
  background: #fff5f5;
  border: 2px solid #fed7d7;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-reset:hover:not(:disabled) {
  background: #fed7d7;
  border-color: #fc8181;
}

.btn-reset:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
/* Переключатель периода */
.period-tabs {
  display: flex;
  gap: 6px;
  background: #fff;
  padding: 6px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.period-tab {
  flex: 1;
  padding: 10px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #718096;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.period-tab:hover {
  background: #edf2f7;
}

.period-tab.active {
  background: #4299e1;
  color: #fff;
}

@media (max-width: 400px) {
  .period-tab {
    font-size: 12px;
    padding: 8px 4px;
  }
}
</style>
